/** Flag emoji for a two-letter country code, e.g. CY -> 🇨🇾. No images needed. */
export const flagFor = (code) => {
  const cc = String(code || '').trim().toUpperCase();
  if (cc.length !== 2 || !/^[A-Z]{2}$/.test(cc)) return '';
  return String.fromCodePoint(...[...cc].map(ch => 0x1f1e6 + ch.charCodeAt(0) - 65));
};

export default flagFor;
